import { AudioFrameExtractor } from './AudioFrameExtractor';
import { ChromeAudioFrameExtractor } from './ChromeAudioFrameExtractor';
export function createAudioFrameExtractor(track) {
    // On chrome MediaStreamTrackProcessor in window object
    if (typeof MediaStreamTrackProcessor !== 'undefined') {
        return new ChromeAudioFrameExtractor(track);
    }
    return new AudioFrameExtractor(track);
}
